var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "panel" }, [
        _vm._m(1),
        _vm._v(" "),
        _vm.paymentType != "Credit Card"
          ? _c("div", { staticClass: "css-grid battery-order-form__row" }, [
              _c("div"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "battery-order__message battery-order__message--success"
                },
                [
                  _vm._v(
                    "\n        Fuel will mail you an invoice after order completion.\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("ProductCartView"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "panel battery-store__nav-row h-center-align" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-primary",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.nextStep($event)
                }
              }
            },
            [_vm._v("Create New Order")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "css-grid battery-order-form__row battery-order-form__row--header battery-order-form__row--success"
      },
      [
        _c("div"),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "battery-order-view__cell battery-order-view__cell--header"
          },
          [_vm._v("Order Received")]
        ),
        _vm._v(" "),
        _c("div")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "css-grid battery-order-form__row" }, [
      _c("div"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "battery-order__message battery-order__message--success"
        },
        [_vm._v("\n        Thank you. Your order has been received.\n      ")]
      ),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }